import { render, staticRenderFns } from "./message-templates.vue?vue&type=template&id=69beb395&scoped=true"
import script from "./message-templates.vue?vue&type=script&lang=js"
export * from "./message-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69beb395",
  null
  
)

export default component.exports